import { Event, EventBus } from "@/modules/Event";

// Loaderコンポーネントを操作するクラス
export default class Loader {
  static show() {
    EventBus.$emit(Event.Loader.Show);
  }

  static hide() {
    EventBus.$emit(Event.Loader.Hide);
  }
}
